import { motion } from 'framer-motion';
import DashboardLayout from '../../components/layout/DashboardLayout';
import HabitTracker from './components/HabitTracker';
import BookLibrary from './components/BookLibrary';
import SkillTracker from './components/SkillTracker';
import './GrowthPage.css';

const GrowthPage = () => {
  return (
    <DashboardLayout>
      <div className="growth-container">
        <motion.div 
          className="page-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1>Growth</h1>
          <p>Track your personal and professional development</p>
        </motion.div>

        <motion.div 
          className="growth-content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <div className="growth-sections">
            <HabitTracker />
            <div className="secondary-section">
              <BookLibrary />
              <SkillTracker />
            </div>
          </div>
        </motion.div>
      </div>
    </DashboardLayout>
  );
};

export default GrowthPage; 